import { marketIdFormat } from "@redotech/redo-xborder-outbound-id";
import * as z from "zod";
import { lcgQuoteBacktestRunOutput } from "./lcg-quote-backtest";

export const LCG_QUOTE_BACKTEST_MAX_ORDERS = 200;

export const startLcgQuoteBacktest = {
  name: "startLcgQuoteBacktest" as const,
  input: z.object({
    marketId: marketIdFormat.schema,
    limit: z
      .number()
      .int()
      .min(1)
      .max(LCG_QUOTE_BACKTEST_MAX_ORDERS)
      .default(LCG_QUOTE_BACKTEST_MAX_ORDERS),
  }),
  output: z.object({ run: lcgQuoteBacktestRunOutput }),
};
